<template>
  <div>
    <div class="container mx-auto flex text-standard xl:mt-50px flex-wrap">
      <div class="hidden md:block w-full h-64 md:h-auto md:w-1/2">
        <iframe
          allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true"
          style="width:100%; height:100%;"
          :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/86d6b5d1-ed63-5a2d-8018-f214d5c3fc41/default/85af7464-2fe9-5eda-9368-816c131bd574/index.html?language=' + $i18n.locale"
        />
      </div>
      <div class="w-full mx-4 md:mx-0 md:w-1/2 xl:pl-12 xl:pr-24">
        <div class="flex content-center mt-4 md:mt-0">
          <img loading="lazy" class="mr-1" src="~/assets/img/examples/rating-star-full.svg">
          <img loading="lazy" class="mx-1" src="~/assets/img/examples/rating-star-full.svg">
          <img loading="lazy" class="mx-1" src="~/assets/img/examples/rating-star-full.svg">
          <img loading="lazy" class="mx-1" src="~/assets/img/examples/rating-star-full.svg">
          <img loading="lazy" class="mx-1" src="~/assets/img/examples/rating-star-empty.svg">
          <div class="flex flex-col justify-center h-8 align-middle pl-4 text-xs">
            (486 ratings)
          </div>
          <div class="flex-grow flex justify-items-end justify-end mr-2">
            <img loading="lazy" src="~/assets/img/share.svg">
          </div>
        </div>
        <h1 class="font-bold text-orange mt-4 text-4xl xl:text-52xl">Braun KF 20</h1>
        <p class="font-bold mt-2 text-2xl xl:text-4xl">&euro; 00,00</p>
        <p class="my-8">
          This is an example of integration of 3D contents inside a website. It
          is intended to suggest ideas of applications on e-commerce and
          info-commerce of the outputs of My AR Studio.<br>
          For further information see <a class="text-orange underline" target="_blank" href="/learn/documentation/distribute/universal-viewer/">our documentation</a>
        </p>
        <div class="block md:hidden w-full" style="height:70vh;">
          <iframe
            allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true"
            style="width:100%; height:100%;"
            :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/86d6b5d1-ed63-5a2d-8018-f214d5c3fc41/default/85af7464-2fe9-5eda-9368-816c131bd574/index.html?language=' + $i18n.locale"
          />
        </div>
        <div class="size-container mt-4 flex flex-row justify-end w-full">
          <div class="text-right"><p class="ml-2 pt-4">Size*</p></div>
          <Dropdown v-model="selectedSize" highlight="orange" :elements="sizeFilter" />
        </div>
        <div class="size-container mb-4 flex flex-row justify-end w-full">
          <div class="text-right"><p class="ml-2 pt-4 text-right">Colour*</p></div>
          <Dropdown v-model="selectedColour" class="" highlight="orange" :elements="colourFilter" />
        </div>
        <div class="qty-container my-8 flex md:w-64 md:justify-start justify-between">
          <div class="border border-braungray w-32 h-auto flex justify-between items-center">
            <button class="h-8" @click="currentQty--">-</button>
            <div class="h-8 pt-1 align-middle">{{ currentQty }}</div>
            <button class="h-8" @click="currentQty++">+</button>
          </div>
          <button class="ml-4 text-xs text-white bg-orange">
            Add to cart
          </button>
        </div>
      </div>
    </div>
    <div class="container mx-auto pt-4">
      <div class="mx-4 lg:mx-0 sm:flex grid grid-cols-3 ">
        <img loading="lazy" class="p-2 pt-0 md:pt-2" src="~/assets/img/examples/braun-small-1.webp">
        <img loading="lazy" class="p-2 pt-0 md:pt-2" src="~/assets/img/examples/braun-small-2.webp">
        <img loading="lazy" class="p-2 pt-0 md:pt-2" src="~/assets/img/examples/braun-small-3.webp">
        <img loading="lazy" class="p-2 pt-0 md:pt-2" src="~/assets/img/examples/braun-small-4.webp">
      </div>
    </div>
    <div class="container mx-auto md:mt-24 xl:mt-150px">
      <div class="xl:mx-24 flex md:mx-8 flex-wrap">
        <div class="p-5 md:p-0 xl:pl-0 md:w-5/6">
          <p class="mt-8 md:mt-0 text-standard text-xl font-bold mb-4 laptop:mb-12 md:text-3xl md:leading-normal xl:leading-tight">
            Product details
          </p>
          <p class="text-standard text-base md:text-base mb-8 xl:mb-12">
            <b>Lorem ipsum</b><br>
            Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
          </p>
          <p class="text-standard text-base md:text-base mb-8 xl:mb-12">
            <b>Lorem ipsum</b><br>
            Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
          </p>
          <p class="text-standard text-base md:text-base mb-8 xl:mb-12">
            <b>Lorem ipsum</b><br>
            Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
          </p>
          <p class="text-standard font-bold flex items-center">
            <img loading="lazy" src="~/assets/img/examples/download-user-manual.svg">
            <span class="ml-8">Download user manual</span>
          </p>
        </div>
        <div class="md:w-1/12" />
        <div class="p-5 md:p-0 xl:pl-0 md:w-5/6 md:pt-24">
          <div class="divide-y divide-braungray xl:ml-12">
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Brand</b>
              </div>
              <div class="w-1/2">
                <p>Braun KF 20</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Model</b>
              </div>
              <div class="w-1/2">
                <p>000000000</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Colour</b>
              </div>
              <div class="w-1/2">
                <p>{{ selectedColour.label }}</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Product size</b>
              </div>
              <div class="w-1/2">
                <p>00 (L) x 00 (W) x 00 (H) inches</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Product weight</b>
              </div>
              <div class="w-1/2">
                <p>00 kg</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Material</b>
              </div>
              <div class="w-1/2">
                <p>Plastic, metal, glass</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2">
                <b>Packaging size</b>
              </div>
              <div class="w-1/2">
                <p>00 (L) x 00 (W) x 00 (H) inches</p>
              </div>
            </div>
            <div class="flex py-4 justify-between">
              <div class="w-1/2 flex">
                <p>More details </p> <img loading="lazy" class="ml-4 inline" src="~/assets/img/examples/arrow-expand.svg">
              </div>
            </div>
          </div>
          <div clas="mt-12">
            <img loading="lazy" src="~/assets/img/examples/braun-ortho.webp">
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto xl:my-150px">
      <img loading="lazy" src="~/assets/img/examples/braun-big-1.webp">
      <img loading="lazy" src="~/assets/img/examples/braun-big-2.webp">
    </div>
    <div class="container mx-auto mt-8 md:mt-24 xl:my-150px">
      <div class="mx-4 xl:mx-24">
        <h3 class="text-orange font-bold text-2xl xl:text-4xl">
          What people say about Braun KF 20
        </h3>
        <div class="mt-8 md:mt-12 xl:mt-100px flex flex-wrap">
          <div class="w-full md:w-1/3 flex h-20 mb-8">
            <div class="h-20 w-20 bg-formgray" />
            <div class="pl-6 flex flex-col justify-between">
              <b>Customer name</b>
              <p class="pb-2">June 25,2020</p>
              <div class="flex content-center">
                <img loading="lazy" class="px-1 pl-0" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-empty.svg">
              </div>
            </div>
          </div>

          <div class="w-full md:w-2/3 flex flex-col mb-12 md:col-span-2">
            <b>Title of the review</b>
            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>
          </div>

          <div class="w-full md:w-1/3 flex h-20 mb-8">
            <div class="h-20 w-20 bg-formgray" />
            <div class="pl-6 flex flex-col justify-between">
              <b>Customer name</b>
              <p class="pb-2">June 25,2020</p>
              <div class="flex content-center">
                <img loading="lazy" class="px-1 pl-0" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
              </div>
            </div>
          </div>

          <div class="w-full md:w-2/3 flex flex-col mb-12 col-span-2">
            <b>Title of the review</b>
            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>
          </div>

          <div class="w-full md:w-1/3 flex h-20 mb-7">
            <div class="h-20 w-20 bg-formgray" />
            <div class="pl-6 flex flex-col justify-between">
              <b>Customer name</b>
              <p class="pb-2">June 25,2020</p>
              <div class="flex content-center">
                <img loading="lazy" class="px-1 pl-0" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-full.svg">
                <img loading="lazy" class="px-1" src="~/assets/img/examples/rating-star-empty.svg">
              </div>
            </div>
          </div>

          <div class="w-full md:w-2/3 flex flex-col mb-12 col-span-2">
            <b>Title of the review</b>
            <p>omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae maiores alias consequatur aut necessitatibus <span class="text-orange">…read more</span></p>
          </div>

          <div class="w-full col-span-3 pointer  mb-12 flex">
            <p class="text-orange">
              See all reviews
            </p>
            <img loading="lazy" class="pl-8 text-orange fill-current" src="~/assets/img/examples/arrow-expand.svg">
          </div>
        </div>
      </div>
    </div>
    <TryIt />
    <div class="hidden md:block">
      <img loading="lazy" class="mx-auto" src="~/assets/img/examples/braun-schema.webp">
    </div>
  </div>
</template>

<script lang="ts">
import Dropdown from '@/components/Dropdown.vue'
import TryIt from '@/components/TryIt.vue'

export default defineNuxtComponent({
  components: {
    TryIt,
    Dropdown
  },
  data: function() {
    return {
      currentQty: 1,
      selectedSize: {
        label: 'Normal',
        value: 'Normal'
      },
      selectedColour: {
        label: 'Orange',
        value: 'Orange'
      },
      sizeFilter: [
        {
          label: 'Normal',
          value: 'Normal'
        },
        {
          label: 'Big',
          value: 'Big'
        },
        {
          label: 'Huge',
          value: 'Huge'
        }
      ],
      colourFilter: [
        {
          label: 'Orange',
          value: 'Orange'
        }
      ]
    }
  }
})
</script>

<style></style>
